export const getIntegrationsUrl = () => 'agency/available_integrations';
export const getIntegrationUrl = (id: string) => `agency/available_integrations/${id}`;
